import { useState, type SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { TabContext, TabPanel } from '@mui/lab'
import { Tabs } from '@dhl-ui/components'
import { useCanViewPpp } from '~/modules/ppp/hooks'
import { PppPage, PppCustomsPage, PppRelationsPage } from '~/modules/ppp/view'
import { links } from '~/AppRoutes'

type TabValue = 'ppp' | 'customs' | 'relations'

export const PppTabs = () => {
  const canAccess = useCanViewPpp()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [selectedTab, setSelectedTab] = useState<TabValue>('ppp')

  const tabs: Record<TabValue, { value: string; label: string; link: string }> = {
    ppp: {
      value: 'ppp',
      label: 'admin.pppPage.title',
      link: links.pppLink(),
    },
    customs: {
      value: 'customs',
      label: 'admin.pppCustomsPage.title',
      link: links.pppCustomsLink(),
    },
    relations: {
      value: 'relations',
      label: 'admin.pppRelationsPage.title',
      link: links.pppRelationsLink(),
    },
  } as const

  const onTabChange = (_: SyntheticEvent<HTMLButtonElement>, newTabValue: string) => {
    const tab = tabs[newTabValue as TabValue]
    if (!tab) return
    setSelectedTab(tab.value as TabValue)
    navigate(tab.link)
  }

  return (
    canAccess && (
      <TabContext value={selectedTab}>
        <Tabs
          value={selectedTab}
          onChange={onTabChange}
          tabs={[
            { value: tabs.ppp.value, label: t(tabs.ppp.label) },
            { value: tabs.customs.value, label: t(tabs.customs.label) },
            { value: tabs.relations.value, label: t(tabs.relations.label) },
          ]}
        />
        <TabPanel value={tabs.ppp.value}>
          <PppPage />
        </TabPanel>
        <TabPanel value={tabs.customs.value}>
          <PppCustomsPage />
        </TabPanel>
        <TabPanel value={tabs.relations.value}>
          <PppRelationsPage />
        </TabPanel>
      </TabContext>
    )
  )
}
